export default {"src":"/_next/static/media/squash.d4e1085a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};